import css from 'styled-jsx/css';

const styles = css.global`.rotoql-team-logo__image{width:100%;height:auto}.rotoql-team-logo__image--tennis{box-shadow:0 0 2px rgba(0,0,0,.3)}`;

export default styles;